import i18n from '../../global/utils/localization';

export const formatDistance = (distance: number) => {
  return `${distance} ${i18n.t('reports.tripsReport.km')}`;
};
